// extracted by mini-css-extract-plugin
export var displayNone = "_uq-6";
export var imgContainer = "_uq-2";
export var overflowHidden = "_uq-3";
export var productInfoCardButtonContainer = "_uq-5";
export var productTitleText = "_uq-4";
export var rightArrow = "_uq-1";
export var rightArrowContainer = "_uq-0";